import { environment } from '@environments/environment';

const hostname = window.location.hostname;
const isLocalDomain = hostname == environment.LOCAL_DOMAIN;

const resolveDomain = (): string => {
  if (isLocalDomain) {
    return environment.LOCAL_DOMAIN;
  }
  return hostname === environment.DOMAIN || hostname.endsWith(`.${environment.DOMAIN}`)
    ? environment.DOMAIN
    : hostname;
};

export const domain = resolveDomain();
export const path = '/';
export const sameSite: 'Lax' = 'Lax';
